import {
  resetWalletItemsOnWebStorage,
  saveSelectedAccountAddressToWebStorage,
  saveWalletAndAccountsToWebStorage
} from "../walletUtils";
import {initialWalletContextValue} from "./WalletContext.constants";
import {WalletContextReducerAction} from "./WalletContext.types";
import {getIsParentSigner} from "./WalletContext.utils";

function walletContextReducer(
  state = initialWalletContextValue,
  action: WalletContextReducerAction
) {
  let newState = state;

  switch (action.type) {
    case "SET_WALLET_TYPE": {
      newState = {
        ...state,
        walletType: action.walletType
      };
      break;
    }

    case "SET_ACCOUNT": {
      const currentSelectedAccount = state.account;
      const nextAccount = action.account.detail;
      const nextAccountAddress = nextAccount?.address;

      // if the account is the same, no need to update the state
      if (
        nextAccountAddress &&
        currentSelectedAccount?.address === nextAccountAddress &&
        currentSelectedAccount?.amount === nextAccount?.amount &&
        currentSelectedAccount?.amountWithoutPendingRewards ===
          nextAccount?.amountWithoutPendingRewards
      ) {
        break;
      }

      if (nextAccountAddress) {
        newState = {
          ...state,
          account: nextAccount,
          accountAssets: action.account.assets
        };

        if (action.setInWalletAccountsAsWell) {
          newState.walletAccounts = (newState.walletAccounts || []).map((walletAccount) =>
            walletAccount.address === nextAccountAddress ? nextAccount! : walletAccount
          );
        }

        saveSelectedAccountAddressToWebStorage(nextAccountAddress);
      } else {
        newState = disconnectAccount();
      }
      break;
    }

    case "SET_WALLET_AND_ACCOUNTS": {
      const walletAccountDetails = action.accounts.map((account) => account.detail);

      newState = {
        ...state,
        walletAccounts: walletAccountDetails,
        walletType: action.walletType
      };
      saveWalletAndAccountsToWebStorage(walletAccountDetails, action.walletType);

      if (action.selectedAccount) {
        newState.account = action.selectedAccount.detail;
        newState.accountAssets = action.selectedAccount.assets;
        saveSelectedAccountAddressToWebStorage(action.selectedAccount.detail.address);
      }
      break;
    }

    case "DISCONNECT": {
      // We can only disconnect if the widget is using the local signer
      if (getIsParentSigner(state.walletType)) {
        console.warn(
          "Disconnect is attempted, but cannot disconnect when using the parent signer. Wallet connection is controlled by the parent app."
        );
      } else {
        newState = disconnectAccount();
      }

      break;
    }

    default:
      break;
  }

  return newState;

  function disconnectAccount(): typeof initialWalletContextValue {
    resetWalletItemsOnWebStorage();

    return {
      ...state,
      account: null,
      accountAssets: [],
      walletAccounts: [],
      walletType: null
    };
  }
}

export default walletContextReducer;
